<template><div><h1>VUX V2.6.5 发布日志</h1>
<h2><a href="/zh-CN/components/cell-box.html">CellBox</a></h2>
<ul><li>[feature] 添加属性 align-items</li>
</ul>
<h2><a href="/zh-CN/components/checklist.html">Checklist</a></h2>
<ul><li>[fix] 修复仅调用 checklist 组件时图标样式不存在 #2041</li>
<li>[fix] 在created时，初始化tempValue值 #2059</li>
</ul>
<h2><a href="/zh-CN/components/confirm.html">Confirm</a></h2>
<ul><li>[enhance] 修复快速点击按钮时触发多次的问题 #2048</li>
</ul>
<h2><a href="/zh-CN/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[feature] 支持事件 on-show on-hide #2053</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[enhance] 兼容同时使用 is-type:china-mobile 和 mask 的情况 @2040</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.6.5 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.6.5-263.vue?ef8d4a30